import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "padding-auth-contents" }
const _hoisted_2 = { class: "text-title-underline" }
const _hoisted_3 = { class: "pt-3 px-3 md:pt-4 md:px-4" }
const _hoisted_4 = { class: "flex justify-end" }
const _hoisted_5 = { class: "shadow-md p-4 hover:bg-gray-50 border border-mentalncText bg-white" }
const _hoisted_6 = { class: "flex items-center flex-wrap" }
const _hoisted_7 = { class: "flex-grow flex flex-wrap items-center" }
const _hoisted_8 = { class: "text-base md:text-xl mr-2" }
const _hoisted_9 = { class: "text-sm md:text-base mr-2" }
const _hoisted_10 = { class: "text-sm md:text-base mr-2" }
const _hoisted_11 = { class: "text-sm md:text-base mr-2" }
const _hoisted_12 = { class: "w-full md:w-auto md:ml-auto mt-2 md:mt-0 text-right md:text-left flex items-center justify-start md:justify-end" }
const _hoisted_13 = { class: "text-xs md:text-base mr-1 text-orange-700" }
const _hoisted_14 = {
  key: 0,
  class: "text-xs md:text-sm bg-gray-500 px-2 rounded-full text-white mr-1"
}
const _hoisted_15 = {
  key: 1,
  class: "text-xs md:text-sm bg-orange-500 px-1 rounded-full text-white flex justify-center items-center"
}
const _hoisted_16 = { class: "p-1" }
const _hoisted_17 = { class: "text-xs md:text-base grid grid-cols-6 md:grid-cols-12 mb-1" }
const _hoisted_18 = { class: "col-span-4 md:col-span-10 ml-1" }
const _hoisted_19 = { class: "text-xs md:text-base grid grid-cols-6 md:grid-cols-12 mb-1" }
const _hoisted_20 = { class: "col-span-4 md:col-span-10 ml-1 overflow-hidden truncate whitespace-nowrap text-ellipsis" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "text-xs md:text-base grid grid-cols-6 md:grid-cols-12" }
const _hoisted_23 = { class: "col-span-4 md:col-span-10 ml-1 overflow-hidden truncate whitespace-nowrap text-ellipsis" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "flex items-center justify-center mt-10" }
const _hoisted_26 = { class: "text-title-underline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_svg_icon = _resolveComponent("base-svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_pagination = _resolveComponent("base-pagination")!
  const _component_CounselingReportSearch = _resolveComponent("CounselingReportSearch")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      _createVNode(_component_layouts_auth_width, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.t('counselingReports.title')) + "一覧", 1),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFilter && _ctx.toggleFilter(...args))),
                  class: _normalizeClass([_ctx.showMyReports ? 'border border-orange-600 hover:bg-orange-600 bg-orange-600 text-white' : 'border border-orange-600 hover:bg-gray-50 bg-white text-orange-600', "flex justify-center items-center w-44 py-1 rounded mb-2 mr-2"])
                }, [
                  _createVNode(_component_base_svg_icon, {
                    class: "min-w-[1.3rem] mr-1",
                    path: _ctx.mdiFilter
                  }, null, 8, ["path"]),
                  _cache[5] || (_cache[5] = _createElementVNode("div", null, "自分のレポート", -1))
                ], 2),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createReport && _ctx.createReport(...args))),
                  class: "text-mentalncText flex justify-center items-center w-28 py-1 bg-white border border-mentalncText hover:bg-gray-50 rounded mb-2 mr-2"
                }, [
                  _createVNode(_component_base_svg_icon, {
                    class: "min-w-[1.3rem] mr-1",
                    path: _ctx.mdiNoteEdit
                  }, null, 8, ["path"]),
                  _cache[6] || (_cache[6] = _createElementVNode("div", null, "新規作成", -1))
                ]),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.store.state.counselingReport.searchDialogVisible = true)),
                  class: "text-blue-600 flex bg-white justify-center items-center w-28 py-1 border border-blue-600 hover:bg-gray-50 rounded mb-2"
                }, [
                  _createVNode(_component_base_svg_icon, {
                    class: "min-w-[1.3rem] mr-1",
                    path: _ctx.mdiFileSearch
                  }, null, 8, ["path"]),
                  _cache[7] || (_cache[7] = _createElementVNode("div", null, "検索", -1))
                ])
              ]),
              (Array.isArray(_ctx.filteredReports) && _ctx.filteredReports.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedList, (report) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: report.id,
                          class: "pb-1 md:pb-2"
                        }, [
                          _createVNode(_component_router_link, {
                            to: `/counseling-reports/${report.id}`
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("p", _hoisted_8, _toDisplayString(report.counseling_client?.nick_name) + " さん", 1),
                                    _createElementVNode("p", _hoisted_9, _toDisplayString(report.counseling_client?.age), 1),
                                    _createElementVNode("p", _hoisted_10, _toDisplayString(report.counseling_client?.gender), 1),
                                    _createElementVNode("p", _hoisted_11, _toDisplayString(report.counseling_client?.residence) + "在住", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("p", _hoisted_13, "カウンセラー：" + _toDisplayString(report.user?.name), 1),
                                    (report.is_hidden)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_14, "非公開中"))
                                      : _createCommentVNode("", true),
                                    (report.user_id === _ctx.userId)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                                          _createVNode(_component_base_svg_icon, {
                                            class: "w-5 md:w-5",
                                            path: _ctx.mdiAccount
                                          }, null, 8, ["path"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("div", _hoisted_17, [
                                    _cache[8] || (_cache[8] = _createElementVNode("p", { class: "col-span-2 md:col-span-2 border-r-4 border-gray-200 ml-0 md:ml-5" }, "実施日", -1)),
                                    _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.dayjs(report.implementation_date).format('YYYY年MM月DD日')), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_19, [
                                    _cache[9] || (_cache[9] = _createElementVNode("p", { class: "col-span-2 md:col-span-2 truncate border-r-4 border-gray-200 ml-0 md:ml-5" }, "セッションテーマ", -1)),
                                    _createElementVNode("div", _hoisted_20, [
                                      (report.counseling_session_themes && report.counseling_session_themes.length > 0)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(report.counseling_session_themes, (theme, index) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                              key: index,
                                              style: _normalizeStyle({ color: theme.theme_color }),
                                              class: "whitespace-nowrap"
                                            }, [
                                              _createTextVNode(_toDisplayString(theme.session_theme_name), 1),
                                              (index < report.counseling_session_themes.length - 1)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, "、"))
                                                : _createCommentVNode("", true)
                                            ], 4))
                                          }), 128))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_22, [
                                    _cache[10] || (_cache[10] = _createElementVNode("p", { class: "col-span-2 md:col-span-2 truncate border-r-4 border-gray-200 ml-0 md:ml-5" }, "扱ったノイズ", -1)),
                                    _createElementVNode("div", _hoisted_23, [
                                      (report.counseling_mental_noises && report.counseling_mental_noises.length > 0)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(report.counseling_mental_noises, (noise, index) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                              key: index,
                                              style: _normalizeStyle({ color: noise.theme_color }),
                                              class: "whitespace-nowrap"
                                            }, [
                                              _createTextVNode(_toDisplayString(noise.mental_noise_name), 1),
                                              (index < report.counseling_mental_noises.length - 1)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_24, "、"))
                                                : _createCommentVNode("", true)
                                            ], 4))
                                          }), 128))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_base_pagination, {
                        pagedList: _ctx.pagedList,
                        "onUpdate:pagedList": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pagedList) = $event)),
                        originalList: _ctx.filteredReports,
                        pageSize: _ctx.pageSize
                      }, null, 8, ["pagedList", "originalList", "pageSize"])
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" カウンセリングレポートが見つかりませんでした。 ")
                  ], 64))
            ])
          ]),
          _createVNode(_component_el_dialog, {
            modelValue: _ctx.store.state.counselingReport.searchDialogVisible,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.store.state.counselingReport.searchDialogVisible) = $event)),
            width: _ctx.store.state.base.responsive.isMD ? '100%' : '60%',
            fullscreen: _ctx.store.state.base.responsive.isMD ? true : false
          }, {
            footer: _withCtx(() => [...(_cache[11] || (_cache[11] = []))]),
            default: _withCtx(() => [
              _createElementVNode("h1", _hoisted_26, _toDisplayString(_ctx.t('counselingReports.title')) + "検索", 1),
              _createVNode(_component_CounselingReportSearch)
            ]),
            _: 1
          }, 8, ["modelValue", "width", "fullscreen"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}